export const localFormat = (n = 0, options?: Intl.NumberFormatOptions) => {
    const locale = navigator.language || 'en-US';
    return n.toLocaleString(locale, options);
};

export const localFormatWithCurrency = (n = 0, currency = 'USD') => {
    const locale = navigator.language || 'en-US';
    const amt = n
        .toLocaleString(locale, {
            style: 'currency',
            currency,
            // minimumFractionDigits: 0, // No digits after the decimal
            // maximumFractionDigits: 0, // No digits after the decimal
        })
        .replaceAll('US', '');

    return amt.indexOf('.') >= 0
        ? amt.replace(/\.?0+$/, '') // removes .000 or 123.4500 => 123.45
        : amt;
};
